// extracted by mini-css-extract-plugin
export default {"AddProductContainer":"AdditionalSpendings_AddProductContainer__aQ5K8"};